import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import MemoraLogo from "../assets/imgs/memora_logo_small.png";

import {
  Button,
  Card,
  Col,
  Input,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import {
  acceptMemoirCollabRequest,
  fetchByEmail,
  getCollaborativesRequests,
  getTimelineRequestUser,
  removeMemoirCollab,
  removeMemoirCollabRequest,
  updateMemoirCollab,
  getCollaborativesInvitation,
  removeMemoirCollabInvitation,
  getCollaborativesInvitationRequests,
  acceptMemoirCollabInvitationRequest,
  rejectMemoirCollabInvitationRequest,
  updateMemoirCollabForNonUser,
} from "../redux/actions/collaboratives.action";
import { useSelector, useDispatch } from "react-redux";
import { getMemoirs, getAllMemoirs } from "../redux/actions/memoir.action";
import moment from "moment";
import { uuid } from "uuidv4";
import { getUsers } from "../redux/actions/user.action";

import LC_Media from "../components/LC_Media";
import MainHeader from "../components/MainHeader";
import { customAlert } from "../redux/actions/alertActions";
import ArrowLeft from "../assets/imgs/new/arrow-left.png";
import ArrowRight from "../assets/imgs/new/arrow-right.png";
import Chips from "react-chips";

function Collaboratives() {
  const [modals, setModals] = useState({
    inviteMember: false,
    delmodal: false,
  });
  const [active, setActive] = useState("-1");
  const { memoirs, allMemoirs } = useSelector((state) => state.memoir);
  const { notifications } = useSelector((state) => state.notification);
  console.log("notifications", notifications);

  const { users } = useSelector((state) => state.user);
  console.log("users", users);
  const {
    collaboratives_requests,
    requestor_data,
    emailUser,
    loading,
    collaboratives_invitation,
    collaboratives_request_invitations,
  } = useSelector((state) => state.collaborative);
  console.log("collaboratives_invitation", collaboratives_invitation);
  const [collaboratives, setCollaboratives] = useState([]);
  const [emailSearch, setEmailSearch] = useState([]);
  const [invitedTo, setInvitedTo] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [memoirID, setMemoirID] = useState("");
  const [collabID, setCollabID] = useState("");
  const [collabRole, setCollabRole] = useState("");
  const [role, setRole] = useState("");
  const { id } = useSelector((state) => state.authUser);
  const dispatch = useDispatch();
  const toggleModal = (name) => {
    let newModal = JSON.parse(JSON.stringify(modals));
    for (let modal of Object.keys(newModal)) {
      if (modal != name) newModal[modal] = false;
    }
    newModal[name] = !newModal[name];
    setModals(newModal);
    setActive("-1");
    setEmailSearch([]);
  };
  const scrollManageContributor = (shift) => {
    let el = document.getElementById("manage-contributor");
    el.scrollLeft += shift;
  };
  const scrollInviteContributor = (shift) => {
    let el = document.getElementById("invite-contributor");
    el.scrollLeft += shift;
  };
  const scrollRequestInvitations = (shift) => {
    let el = document.getElementById("scrollReqInvitations");
    el.scrollLeft += shift;
  };
  const scrollCollabRequest = (shift) => {
    let el = document.getElementById("collab_request");
    el.scrollLeft += shift;
  };
  const scrollCollabInvite = (shift) => {
    let el = document.getElementById("collab_invite");
    el.scrollLeft += shift;
  };
  const setActiveMedia = (idx) => {
    setActive(idx);
  };
  const getCollabRequest = (id) => {
    if (id != undefined) {
      let obj = users.length > 0 && users.find((user) => user.id == id);
      if (obj != null) {
        return obj;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };
  const getMemoirDetails = (id) => {
    if (id != undefined) {
      let obj =
        allMemoirs.length > 0 && allMemoirs.find((memoir) => memoir.id == id);
      if (obj != null) {
        return obj;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };

  const getRole = (memId, uid) => {
    let memoirData = memoirs.find((mem) => mem.id == memId);
    let roleCheck = memoirData.collaborators.find((collab) => collab.id == uid);
    if (roleCheck) {
      return roleCheck.role;
    } else {
      return "owner";
    }
  };
  const getUserDetails = (id) => {
    if (id != undefined) {
      let obj = users.length > 0 && users.find((user) => user.id == id);
      if (obj != null) {
        return obj;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };
  console.log("getUserDetails", getUserDetails());
  useEffect(() => {
    let tempUsers = [];

    users?.forEach((user) => {
      if (user.firstname && user.lastname && user.email) {
        tempUsers.push({
          value: user.id,
          label: user.firstname + " " + user.lastname + " " + user.email,
        });
      }
    });
    setUserOptions(tempUsers);
  }, [users]);

  useEffect(() => {
    if (collaboratives_requests.length == 0) {
      dispatch(getCollaborativesRequests(id));
    }
    if (users.length == 0) {
      dispatch(getUsers());
    }
    if (memoirs.length == 0) {
      dispatch(getMemoirs(id));
    }

    if (allMemoirs.length == 0) {
      dispatch(getAllMemoirs());
    }

    if (collaboratives_invitation.length == 0) {
      dispatch(getCollaborativesInvitation(id));
    }
    if (collaboratives_request_invitations.length == 0) {
      dispatch(getCollaborativesInvitationRequests(id));
    }
  }, []);

  const clearFields = () => {
    setMemoirID("");
    setRole("");
    setEmailSearch([]);
    setInvitedTo([]);
  };
  const handleEmailSearch = (chips) => {
    setEmailSearch(chips);
  };
  console.log(userOptions, "userOptions");
  return (
    <>
      <div className="container-fluid pt-3">
        <MainHeader heading={"Collaboratives"} />
        <hr className="mb-0" />
        <div className="mt-5 manage-contributors">
          <div className="d-block d-lg-flex align-items-center">
            <div>
              <h5 className="font-weight-bold">New Timeline access requests</h5>
            </div>
            <button
              className="ml-auto btn btn-outline px-3 dashboard-btn"
              style={{ minWidth: "auto" }}
              //   onClick={(e) => {
              //     e.preventDefault();
              //     toggleModal("inviteMember");
              //   }}
            >
              History
            </button>
          </div>

          <Row
            id="collab_invite"
            className="flex-nowrap mt-4"
            style={{ overflow: "auto", scrollBehavior: "smooth" }}
          >
            {notifications && notifications.length > 0 ? (
              notifications.map((noti) => {
                if (noti.type == "collab") {
                  if (noti.status == "invited") {
                    return (
                      <>
                        <Col style={{ flexBasis: "37%", flexShrink: 0 }}>
                          <Card
                            className="p-4 h-100"
                            style={{
                              bordrRadius: 8,
                              background: "#F7F5F0",
                            }}
                          >
                            <div className="d-flex">
                              <div className="mr-2">
                                <Avatar
                                  round={true}
                                  className="memoir_no_display_img"
                                  src={
                                    getUserDetails(noti.user_id).profile_image
                                  }
                                  size={48}
                                />
                              </div>
                              <div>
                                <p className="m-0 font-weight-bold">
                                  {getUserDetails(noti.user_id).firstname}{" "}
                                  {getUserDetails(noti.user_id).lastname}
                                </p>
                                <small className="text-muted">
                                  {moment
                                    .unix(noti.created_at.seconds)
                                    .format("DD/MM/YYYY")}
                                </small>
                                <p className="notification_text">
                                  {getUserDetails(noti.user_id).firstname}{" "}
                                  invited you to there memoir{" "}
                                  {getMemoirDetails(noti.memoir_id) != "N/A" ? (
                                    <>
                                      {
                                        getMemoirDetails(noti.memoir_id)
                                          .memoir_title
                                      }
                                    </>
                                  ) : (
                                    "N/A"
                                  )}
                                </p>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </>
                    );
                  } else if (noti.status == "accepted") {
                    return (
                      <Col style={{ flexBasis: "37%", flexShrink: 0 }}>
                        <Card
                          className="p-4 h-100"
                          style={{
                            bordrRadius: 8,
                            background: "#F7F5F0",
                          }}
                        >
                          <div className="d-flex">
                            <div className="mr-2">
                              <Avatar
                                round={true}
                                className="memoir_no_display_img"
                                src={getUserDetails(noti.user_id).profile_image}
                                size={48}
                              />
                            </div>
                            <div>
                              <p className="m-0 font-weight-bold">
                                {getUserDetails(noti.user_id).firstname}{" "}
                                {getUserDetails(noti.user_id).lastname}
                              </p>
                              <small className="text-muted">
                                {moment
                                  .unix(noti.created_at.seconds)
                                  .format("DD/MM/YYYY")}
                              </small>
                              <p className="notification_text">
                                {getUserDetails(noti.user_id).firstname}{" "}
                                accepted your request to join memoir{" "}
                                {getMemoirDetails(noti.memoir_id) != "N/A" ? (
                                  <>
                                    {
                                      getMemoirDetails(noti.memoir_id)
                                        .memoir_title
                                    }
                                  </>
                                ) : (
                                  "N/A"
                                )}
                              </p>
                            </div>
                          </div>
                        </Card>
                      </Col>
                    );
                  } else if (noti.status == "requested") {
                    return (
                      <>
                        <Col style={{ flexBasis: "37%", flexShrink: 0 }}>
                          <Card
                            className="p-4 h-100"
                            style={{
                              bordrRadius: 8,
                              background: "#F7F5F0",
                            }}
                          >
                            <div className="d-flex">
                              <div className="mr-2">
                                <Avatar
                                  round={true}
                                  className="memoir_no_display_img"
                                  src={
                                    getUserDetails(noti.user_id).profile_image
                                  }
                                  size={48}
                                />
                              </div>
                              <div>
                                <p className="m-0 font-weight-bold">
                                  {getUserDetails(noti.user_id).firstname}{" "}
                                  {getUserDetails(noti.user_id).lastname}
                                </p>
                                <small className="text-muted">
                                  {moment
                                    .unix(noti.created_at.seconds)
                                    .format("DD/MM/YYYY")}
                                </small>
                                <p className="notification_text">
                                  {getUserDetails(noti.user_id).firstname}{" "}
                                  requested to join your memoir{" "}
                                  {getMemoirDetails(noti.memoir_id) != "N/A" ? (
                                    <>
                                      {
                                        getMemoirDetails(noti.memoir_id)
                                          .memoir_title
                                      }
                                    </>
                                  ) : (
                                    "N/A"
                                  )}
                                </p>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </>
                    );
                  }
                } else if (noti.type == "order") {
                  if (noti.status == "placed") {
                    return (
                      <>
                        <Col style={{ flexBasis: "37%", flexShrink: 0 }}>
                          <Card
                            className="p-4 h-100"
                            style={{
                              bordrRadius: 8,
                              background: "#F7F5F0",
                            }}
                          >
                            <div className="d-flex">
                              <div className="mr-2">
                                <Avatar
                                  round={true}
                                  className="memoir_no_display_img"
                                  src={
                                    getUserDetails(noti.user_id).profile_image
                                  }
                                  size={48}
                                />
                              </div>
                              <div>
                                <p className="m-0 font-weight-bold">
                                  {getUserDetails(noti.user_id).firstname}{" "}
                                  {getUserDetails(noti.user_id).lastname}
                                </p>
                                <small className="text-muted">
                                  {moment
                                    .unix(noti.created_at.seconds)
                                    .format("DD/MM/YYYY")}
                                </small>
                                <p className="notification_text">
                                  Your order has been placed
                                </p>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <Col style={{ flexBasis: "37%", flexShrink: 0 }}>
                          <Card
                            className="p-4 h-100"
                            style={{
                              bordrRadius: 8,
                              background: "#F7F5F0",
                            }}
                          >
                            <div className="d-flex">
                              <div className="mr-2">
                                <Avatar
                                  round={true}
                                  className="memoir_no_display_img"
                                  src={
                                    getUserDetails(noti.user_id).profile_image
                                  }
                                  size={48}
                                />
                              </div>
                              <div>
                                <p className="m-0 font-weight-bold">
                                  {getUserDetails(noti.user_id).firstname}{" "}
                                  {getUserDetails(noti.user_id).lastname}
                                </p>
                                <small className="text-muted">
                                  {moment
                                    .unix(noti.created_at.seconds)
                                    .format("DD/MM/YYYY")}
                                </small>
                                <p className="notification_text">
                                  Your order with order id (
                                  {noti.order_id ? noti.order_id : "N/A"}) is{" "}
                                  {noti.status ? noti.status : "N/A"}
                                </p>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </>
                    );
                  }
                }
              })
            ) : (
              <div className="d-flex justify-content-center">
                <p className="notification_text">
                  You don't have any notification
                </p>
              </div>
            )}
          </Row>
          {collaboratives_invitation.length > 2 && (
            <div className="text-right mt-2">
              <img
                src={ArrowLeft}
                alt="left"
                className="pointer"
                onClick={() => scrollCollabInvite(-180)}
              />
              <span className="ml-3 mr-1">{1}</span>-
              <span className="ml-1 mr-3">
                {collaboratives_invitation.length}
              </span>
              <img
                src={ArrowRight}
                alt="right"
                className="pointer"
                onClick={() => scrollCollabInvite(180)}
              />
            </div>
          )}
        </div>
        {/* Access Invitation */}
        <div className="d-flex mt-5 align-items-center">
          <div>
            <h5 className="font-weight-bold">
              Memoir Access Invitations{" "}
              <small>
                (Your Invitations sent for collaboration on your memoir)
              </small>
            </h5>
          </div>
        </div>
        <Row
          id="collab_invite"
          className="flex-nowrap mt-2"
          style={{ overflow: "auto", scrollBehavior: "smooth" }}
        >
          {collaboratives_invitation.length > 0 ? (
            collaboratives_invitation.map((collab, index) => {
              return (
                <Col style={{ flexBasis: "37%", flexShrink: 0 }}>
                  <Card
                    className="p-4 h-100"
                    style={{
                      bordrRadius: 8,
                      background: "#F7F5F0",
                    }}
                  >
                    <div className="d-flex">
                      <div className="mr-2">
                        <Avatar
                          round={true}
                          className="memoir_no_display_img"
                          src={
                            getCollabRequest(collab.invited_to) != "N/A"
                              ? getCollabRequest(collab.invited_to)
                                  .profile_image
                                ? getCollabRequest(collab.invited_to)
                                    .profile_image
                                : MemoraLogo
                              : MemoraLogo
                          }
                          size={48}
                        />
                      </div>
                      <div>
                        <p className="m-0 font-weight-bold">
                          {getCollabRequest(collab.invited_to) != "N/A" ? (
                            <>
                              {getCollabRequest(collab.invited_to).firstname}{" "}
                              {getCollabRequest(collab.invited_to).lastname}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </p>
                        <small className="text-muted">
                          {moment
                            .unix(collab.invited_at.seconds)
                            .format("DD/MM/YYYY")}
                        </small>
                        <p style={{ fontSize: 14 }} className="m-0">
                          You request to{" "}
                          <strong>
                            {getCollabRequest(collab.invited_to).firstname}
                          </strong>{" "}
                          to be an {collab.role} of your{" "}
                          <strong>
                            {getMemoirDetails(collab.memoir_id) != "N/A" ? (
                              <>
                                {
                                  getMemoirDetails(collab.memoir_id)
                                    .memoir_title
                                }
                              </>
                            ) : (
                              "N/A"
                            )}
                          </strong>{" "}
                          memoir
                        </p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className="d-flex ml-auto f-14"
                        style={{ color: "#28B446" }}
                      >
                        <span>{collab.status}</span>
                        <span
                          className="ml-3 pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch(removeMemoirCollabInvitation(collab.id));
                          }}
                          style={{ color: "red" }}
                        >
                          Delete
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
              );
            })
          ) : (
            <p className="ml-5">
              <strong>No Requests Found</strong>
            </p>
          )}
        </Row>
        {collaboratives_invitation.length > 2 && (
          <div className="text-right mt-2">
            <img
              src={ArrowLeft}
              alt="left"
              className="pointer"
              onClick={() => scrollCollabInvite(-180)}
            />
            <span className="ml-3 mr-1">{1}</span>-
            <span className="ml-1 mr-3">
              {collaboratives_invitation.length}
            </span>
            <img
              src={ArrowRight}
              alt="right"
              className="pointer"
              onClick={() => scrollCollabInvite(180)}
            />
          </div>
        )}
        {/* Access invitation Requests */}
        <div className="d-flex mt-5 align-items-center">
          <div>
            <h5 className="font-weight-bold">
              Memoir access invites requests{" "}
              <small>
                (Someone inviting you as collaborator on their memoir)
              </small>
            </h5>
          </div>
        </div>
        <Row
          id="scrollReqInvitations"
          className="flex-nowrap mt-2"
          style={{ overflow: "auto", scrollBehavior: "smooth" }}
        >
          {collaboratives_request_invitations.length > 0 ? (
            collaboratives_request_invitations.map((collab, index) => {
              return (
                <Col
                  style={{
                    flexBasis: "37%",
                    flexShrink: 0,
                  }}
                >
                  <Card
                    className="p-4 h-100"
                    style={{
                      bordrRadius: 8,
                      background: "#F7F5F0",
                    }}
                  >
                    <div className="d-flex">
                      <div className="mr-2">
                        <Avatar
                          round={true}
                          className="memoir_no_display_img"
                          src={
                            getCollabRequest(collab.invited_by) != "N/A"
                              ? getCollabRequest(collab.invited_by)
                                  .profile_image
                                ? getCollabRequest(collab.invited_by)
                                    .profile_image
                                : MemoraLogo
                              : MemoraLogo
                          }
                          size={48}
                        />
                      </div>
                      <div>
                        <p className="m-0 font-weight-bold">
                          {getCollabRequest(collab.invited_by) != "N/A" ? (
                            <>
                              {getCollabRequest(collab.invited_by).firstname}{" "}
                              {getCollabRequest(collab.invited_by).lastname}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </p>
                        <small className="text-muted">
                          {moment
                            .unix(collab.invited_at.seconds)
                            .format("DD/MM/YYYY")}
                        </small>
                        <p style={{ fontSize: 14 }} className="m-0">
                          You've a request from{" "}
                          <strong>
                            {getCollabRequest(collab.invited_by).firstname}
                          </strong>{" "}
                          to be an {collab.role} of his{" "}
                          <strong>
                            {getMemoirDetails(collab.memoir_id) != "N/A" ? (
                              <>
                                {
                                  getMemoirDetails(collab.memoir_id)
                                    .memoir_title
                                }
                              </>
                            ) : (
                              "N/A"
                            )}
                          </strong>{" "}
                          memoir
                        </p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className="d-flex ml-auto f-14"
                        style={{ color: "#28B446" }}
                      >
                        <span
                          className="pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            let obj = {
                              id: collab.invited_to,
                              role: collab.role,
                            };

                            dispatch(
                              acceptMemoirCollabInvitationRequest(
                                collab.memoir_id,
                                obj,
                                collab.id,
                                collab.invited_by
                              )
                            );
                          }}
                        >
                          Accept
                        </span>
                        <span
                          className="ml-3 pointer"
                          style={{ color: "red" }}
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch(removeMemoirCollabInvitation(collab.id));
                            // rejectMemoirCollabInvitationRequest(collab.id)
                          }}
                        >
                          Decline
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
              );
            })
          ) : (
            <p className="ml-5">
              <strong>No Requests Found</strong>
            </p>
          )}
        </Row>
        {collaboratives_request_invitations.length > 2 && (
          <div className="text-right mt-2">
            <img
              src={ArrowLeft}
              alt="left"
              className="pointer"
              onClick={() => scrollRequestInvitations(-180)}
            />
            <span className="ml-3 mr-1">{1}</span>-
            <span className="ml-1 mr-3">
              {collaboratives_request_invitations.length}
            </span>
            <img
              src={ArrowRight}
              alt="right"
              className="pointer"
              onClick={() => scrollRequestInvitations(180)}
            />
          </div>
        )}

        {/* New Memoir Access Requests */}
        <div className="d-flex mt-5 align-items-center">
          <div>
            <h5 className="font-weight-bold">
              New Memoir access requests{" "}
              <small>
                (Someone requesting to be collaborator of your memoir)
              </small>
            </h5>
          </div>
        </div>
        <Row
          id="collab_request"
          className="flex-nowrap mt-2"
          style={{ overflow: "auto", scrollBehavior: "smooth" }}
        >
          {collaboratives_requests.length > 0 ? (
            collaboratives_requests.map((collab, index) => {
              return (
                <Col style={{ flexBasis: "37%", flexShrink: 0 }}>
                  <Card
                    className="p-4 h-100"
                    style={{
                      bordrRadius: 8,
                      background: "#F7F5F0",
                    }}
                  >
                    <div className="d-flex">
                      <div className="mr-2">
                        <Avatar
                          round={true}
                          className="memoir_no_display_img"
                          src={
                            getCollabRequest(collab.requestor_id) != "N/A"
                              ? getCollabRequest(collab.requestor_id)
                                  .profile_image
                                ? getCollabRequest(collab.requestor_id)
                                    .profile_image
                                : MemoraLogo
                              : MemoraLogo
                          }
                          size={48}
                        />
                      </div>
                      <div>
                        <p className="m-0 font-weight-bold">
                          {getCollabRequest(collab.requestor_id) != "N/A" ? (
                            <>
                              {getCollabRequest(collab.requestor_id).firstname}{" "}
                              {getCollabRequest(collab.requestor_id).lastname}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </p>
                        <small className="text-muted">
                          {moment
                            .unix(collab.created.seconds)
                            .format("DD/MM/YYYY")}
                        </small>
                        <p style={{ fontSize: 14 }} className="m-0">
                          You've a request from{" "}
                          <strong>
                            {getCollabRequest(collab.requestor_id).firstname}
                          </strong>{" "}
                          to be an {collab.role} of your{" "}
                          <strong>
                            {getMemoirDetails(collab.memoir_id) != "N/A" ? (
                              <>
                                {
                                  getMemoirDetails(collab.memoir_id)
                                    .memoir_title
                                }
                              </>
                            ) : (
                              "N/A"
                            )}
                          </strong>{" "}
                          memoir
                        </p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className="d-flex ml-auto f-14"
                        style={{ color: "#28B446" }}
                      >
                        <span
                          className="pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            let obj = {
                              id: collab.requestor_id,
                              role: collab.role,
                            };
                            dispatch(
                              acceptMemoirCollabRequest(
                                collab.memoir_id,
                                obj,
                                collab.id,
                                collab.memoir_creator
                              )
                            );
                          }}
                        >
                          Accept
                        </span>
                        <span
                          className="ml-3 pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch(removeMemoirCollabRequest(collab.id));
                          }}
                        >
                          Decline
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
              );
            })
          ) : (
            <p className="ml-5">
              <strong>No Requests Found</strong>
            </p>
          )}
        </Row>
        {collaboratives_requests.length > 2 && (
          <div className="text-right mt-2">
            <img
              src={ArrowLeft}
              alt="left"
              className="pointer"
              onClick={() => scrollCollabRequest(-180)}
            />
            <span className="ml-3 mr-1">{1}</span>-
            <span className="ml-1 mr-3">{collaboratives_requests.length}</span>
            <img
              src={ArrowRight}
              alt="right"
              className="pointer"
              onClick={() => scrollCollabRequest(180)}
            />
          </div>
        )}

        <div className="mt-5 manage-contributors">
          <div className="d-block d-lg-flex align-items-center">
            <div>
              <h5 className="font-weight-bold">Manage Contributors</h5>
            </div>
            <button
              className="ml-auto btn btn-outline px-3 dashboard-btn"
              style={{ minWidth: "auto" }}
              onClick={(e) => {
                e.preventDefault();
                toggleModal("inviteMember");
              }}
            >
              <i className="fa fa-users mr-2" />
              Invite Member
            </button>
          </div>
          {/* <Row className="mt-2">
            <Col md="3">
              <Label>Selected Date</Label>
              <Input type="date"></Input>
            </Col>
          </Row> */}
          <Row
            id="manage-contributor"
            noGutters
            className="flex-nowrap mt-3"
            style={{ overflow: "auto", scrollBehavior: "smooth" }}
          >
            {memoirs.length > 0 &&
              memoirs.map((memoir, idx) => (
                <Col lg="4" md="6" xs="12">
                  <LC_Media
                    active={active == idx}
                    setActiveMedia={(e) => setActiveMedia(idx)}
                    memoir={memoir}
                    setCollaboratives={setCollaboratives}
                    setMemoirID={setMemoirID}
                  />
                </Col>
              ))}
          </Row>
          {memoirs.length > 3 && (
            <div className="text-right mt-2">
              <img
                src={ArrowLeft}
                alt="left"
                className="pointer"
                onClick={() => scrollManageContributor(-380)}
              />
              <span className="ml-3 mr-1">{1}</span>-
              <span className="ml-1 mr-3">{memoirs.length}</span>
              <img
                src={ArrowRight}
                alt="right"
                className="pointer"
                onClick={() => scrollManageContributor(380)}
              />
            </div>
          )}
        </div>
        <div className="d-block d-md-flex align-items-center">
          <div>
            <h5 className="font-weight-bold m-0">
              Collaborators / Contributors :
            </h5>
          </div>
        </div>
        {active == "-1" ? (
          <p className="mt-5">
            "Please Select Memoir to See Collaborators/Contributors"
          </p>
        ) : (
          <Row className="mt-4">
            <Col xl="7">
              {collaboratives != undefined && collaboratives.length != 0 ? (
                <Table borderless>
                  <thead
                    className="f-14"
                    style={{
                      borderBottom: "1px solid #000000",
                    }}
                  >
                    {/* <th></th> */}
                    <th>IMG</th>
                    <th>NAME</th>
                    {/* <th>LAST VISIT</th> */}
                    <th>STATUS</th>
                    <th></th>
                  </thead>
                  <tbody>
                    {collaboratives.map((collab, idx) => (
                      <tr>
                        {/* <td
                              style={{
                                verticalAlign: "middle",
                              }}
                            >
                              <CustomInput
                                type="checkbox"
                                id={`checkboxTable${idx}`}
                              ></CustomInput>
                            </td> */}
                        <td
                          style={{
                            verticalAlign: "middle",
                          }}
                        >
                          {/* <img src={avatar_table} /> */}
                          <Avatar
                            round={true}
                            className="memoir_no_display_img"
                            src={
                              getCollabRequest(collab.id) != "N/A"
                                ? getCollabRequest(collab.id).profile_image
                                  ? getCollabRequest(collab.id).profile_image
                                  : MemoraLogo
                                : MemoraLogo
                            }
                            size={48}
                          />
                        </td>
                        <td
                          style={{
                            verticalAlign: "middle",
                          }}
                          className="font-weight-bold"
                        >
                          {getCollabRequest(collab.id) != "N/A" ? (
                            <>
                              {getCollabRequest(collab.id).firstname}{" "}
                              {getCollabRequest(collab.id).lastname}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        {/* <td
                              style={{
                                fontSize: 12,
                                verticalAlign: "middle",
                              }}
                            >
                              10/2/2021
                            </td> */}
                        <td
                          style={{
                            verticalAlign: "middle",
                          }}
                        >
                          <Input type="select">
                            <option>{collab.role}</option>
                          </Input>
                        </td>
                        <td>
                          <i
                            // id="TooltipRemove"
                            className="fa fa-times mt-3 pointer text-danger"
                            onClick={(e) => {
                              e.preventDefault();
                              setCollabID(collab.id);
                              setCollabRole(collab.role);
                              toggleModal("delmodal");
                            }}
                          ></i>
                          {/* <i
                                // id="TooltipDetail"
                                className="fa fa-eye ml-3 mt-3 pointer text-info"
                                onClick={
                                  (e) => {
                                    e.preventDefault()
                                    setCollabID(collab.id)
                                  }
                                }
                              ></i> */}
                        </td>
                      </tr>
                    ))}
                    {/* <Tooltip placement="top" isOpen={toolTip.detailTooltip} target="TooltipDetail" toggle={() => toggleToolTip("detailTooltip")}>
                          View Shared Memoirs
                        </Tooltip>
                        <Tooltip placement="top" isOpen={toolTip.removeTooltip} target="TooltipRemove" toggle={() => toggleToolTip("removeTooltip")}>
                          Remove Collaborator
                        </Tooltip> */}
                  </tbody>
                </Table>
              ) : (
                "No Collaborators Found"
              )}
            </Col>
          </Row>
        )}
      </div>
      <Modal
        isOpen={modals.inviteMember}
        size="xl"
        centered
        className="custom-modal"
        toggle={(e) => {
          clearFields();
          toggleModal("inviteMember");
        }}
      >
        <ModalBody>
          <div className="modal-content-wrapper ">
            <div className="d-flex">
              <span
                className="ml-auto pointer"
                onClick={(e) => toggleModal("inviteMember")}
              >
                <i className="fa fa-times"></i>
              </span>
            </div>
            <h5 className="mt-3 text-center font-weight-bold">
              Inviting contributors to add memories
            </h5>
            <div className="d-flex mt-3"></div>
            <div className="d-flex">
              <div className="position-relative w-100">
                <label>Enter Email (not registered on platform)</label>
                <Chips
                  value={emailSearch}
                  onChange={handleEmailSearch}
                  className="form-control "
                  placeholder="Enter Recipient Email..."
                />
                {/* <input
									type='email'
									className='form-control '
									placeholder='Enter Recipient Email...'
									value={emailSearch}
									onChange={e =>
										setEmailSearch(e.target.value)
									}
								></input> */}
              </div>
            </div>
            <Row
              id="invite-contributor"
              className="mt-4 flex-nowrap"
              noGutters
              style={{
                overflow: "auto",
                scrollBehavior: "smooth",
              }}
            >
              {memoirs.length > 0 &&
                memoirs.map((memoir, idx) => (
                  <Col xl="4" lg="6">
                    <LC_Media
                      active={active == idx}
                      setActiveMedia={(e) => setActiveMedia(idx)}
                      memoir={memoir}
                      setCollaboratives={setCollaboratives}
                      setMemoirID={setMemoirID}
                    />
                  </Col>
                ))}
            </Row>
            {memoirs.length > 3 && (
              <div className="text-right mt-2">
                <img
                  src={ArrowLeft}
                  alt="left"
                  className="pointer"
                  onClick={() => scrollInviteContributor(-380)}
                />
                <span className="ml-3 mr-1">{1}</span>-
                <span className="ml-1 mr-3">{memoirs.length}</span>
                <img
                  src={ArrowRight}
                  alt="right"
                  className="pointer"
                  onClick={() => scrollInviteContributor(380)}
                />
              </div>
            )}
            <label>Search existing Memories users</label>
            <Autocomplete
              multiple
              id="tags-standard"
              options={userOptions}
              clearIcon={false}
              filterSelectedOptions
              getOptionLabel={(option) => option.label}
              onChange={(e, value) => {
                setInvitedTo(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label=""
                  placeholder="Select User..."
                />
              )}
            />
            {/* <Input
							type='select'
							className='form-control '
							placeholder='Select User...'
							// value={invitedTo}
							onChange={e => setInvitedTo(e.target.value)}
						>
							<option value='' disabled selected>
								Select Existing User
							</option>
							{users
								?.filter(user => user.firstname)
								.map(user => {
									return (
										<option value={user.id}>
											{user.firstname} {user.lastname}
										</option>
									);
								})}
						</Input> */}

            <div className="access-level mt-5">
              <label>Select their access level</label>
              <div className="d-flex radio-group">
                <div className="d-flex radio align-items-center">
                  <input
                    type="radio"
                    name="role"
                    value="admin"
                    onChange={(e) => setRole(e.target.value)}
                  />
                  <span className="ml-2">Admin</span>
                </div>
                <div className="ml-5 d-flex radio align-items-center">
                  <input
                    type="radio"
                    name="role"
                    value="contributer"
                    onChange={(e) => setRole(e.target.value)}
                  />
                  <span className="ml-2">Contributer</span>
                </div>
              </div>
            </div>
            <div className="row mt-4 justify-content-center">
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-6">
                    <button
                      className="btn btn-outline d-block w-100 dashboard-btn"
                      onClick={async (e) => {
                        e.preventDefault();
                        if (invitedTo.length == 0 && emailSearch.length == 0) {
                          dispatch(customAlert(true, "Please Select User"));
                          setTimeout(() => {
                            dispatch(customAlert(false, ""));
                          }, 1500);
                        } else {
                          if (memoirID == "" || role == "") {
                            dispatch(
                              customAlert(true, "Please Select All fields")
                            );
                            setTimeout(() => {
                              dispatch(customAlert(false, ""));
                            }, 1500);
                            // toast.warning(
                            // 	'Please Select All fields'
                            // );
                          } else {
                            if (getRole(memoirID, id) == "contributer") {
                              dispatch(
                                customAlert(
                                  true,
                                  "Contributor cannot invite members!"
                                )
                              );
                              setTimeout(() => {
                                dispatch(customAlert(false, ""));
                              }, 1500);
                              // toast.warning(
                              // 	'Contributor cannot invite members!'
                              // );
                            } else {
                              if (
                                invitedTo?.find(
                                  (invited) =>
                                    invited.value ==
                                    getMemoirDetails(memoirID).user_id
                                )
                              ) {
                                dispatch(
                                  customAlert(
                                    true,
                                    "Selected user is the creator of this memoir!"
                                  )
                                );
                                setTimeout(() => {
                                  dispatch(customAlert(false, ""));
                                }, 1500);
                                // toast.warning(
                                // 	'Selected user is the creator of this memoir!'
                                // );
                              } else {
                                if (emailSearch?.length == 0) {
                                  invitedTo.length > 0 &&
                                    invitedTo.forEach((invited) => {
                                      let exisObj = {
                                        id: invited.value,
                                        role: role,
                                      };
                                      dispatch(
                                        updateMemoirCollab(
                                          memoirID,
                                          exisObj,
                                          id
                                        )
                                      );
                                    });
                                  clearFields();
                                  toggleModal("inviteMember");
                                } else if (invitedTo.length == 0) {
                                  emailSearch.length > 0 &&
                                    emailSearch.forEach((email) => {
                                      let newObj = {
                                        id: uuid(),
                                        email: email,
                                        role,
                                      };
                                      dispatch(
                                        updateMemoirCollabForNonUser(
                                          memoirID,
                                          newObj,
                                          id
                                        )
                                      );
                                    });

                                  clearFields();
                                  toggleModal("inviteMember");
                                } else if (
                                  emailSearch?.length > 0 &&
                                  invitedTo?.length > 0
                                ) {
                                  emailSearch.length > 0 &&
                                    emailSearch.forEach((email) => {
                                      let newObj = {
                                        id: uuid(),
                                        email: email,
                                        role,
                                      };
                                      dispatch(
                                        updateMemoirCollabForNonUser(
                                          memoirID,
                                          newObj,
                                          id
                                        )
                                      );
                                    });
                                  invitedTo.length > 0 &&
                                    invitedTo.forEach((invited) => {
                                      let exisObj = {
                                        id: invited.value,
                                        role: role,
                                      };
                                      dispatch(
                                        updateMemoirCollab(
                                          memoirID,
                                          exisObj,
                                          id
                                        )
                                      );
                                    });

                                  clearFields();
                                  toggleModal("inviteMember");
                                }
                              }
                            }
                          }
                        }
                      }}
                      disabled={loading}
                    >
                      {loading ? <Spinner size="sm" /> : "Add"}
                    </button>
                  </div>
                  <div className="col-md-6 mt-3 mt-md-0">
                    <button
                      className="btn btn-outline d-block w-100 dashboard-btn"
                      onClick={(e) => {
                        clearFields();
                        toggleModal("inviteMember");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Delete Modal */}
      <Modal
        isOpen={modals.delmodal}
        centered
        className="custom-modal"
        toggle={(e) => toggleModal("delModal")}
      >
        <ModalBody>
          <div className="text-center">
            <i
              className="far fa-times-circle text-danger"
              style={{ fontSize: 70 }}
            ></i>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              Do you really want to remove this collaborator? This process
              cannot be undone.
            </span>
            <br />
            <br />
            <br />
            <Button color="secondary" onClick={(e) => toggleModal("delModal")}>
              Cancel
            </Button>{" "}
            <Button
              color="danger"
              onClick={async (e) => {
                e.preventDefault();
                if (memoirID != "" && collabID != "") {
                  let obj = {
                    id: collabID,
                    role: collabRole,
                  };
                  await dispatch(removeMemoirCollab(memoirID, obj));
                  toggleModal("delModal");
                } else {
                  dispatch(
                    customAlert(true, "Try selecting memoir & collab again!")
                  );
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                  // toast.warning(
                  // 	'Try selecting memoir & collab again!'
                  // );
                }
              }}

              // disabled={this.state.filesUrl.length<5}
            >
              Remove
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Collaboratives;
